var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketfuelCircular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "url(#rocketfuel-circular_svg__paint0_radial_1683_85794)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.802 40.932H24.908V27.979h4.815l-4.313-6.116h-7.574V62.65h7.072V47.095h18.207l-4.313-6.163zM59.016 45.458a10.971 10.971 0 003.51-2.408 10.318 10.318 0 002.308-3.563c.566-1.53.838-3.145.802-4.767 0-3.997-1.253-7.127-3.761-9.39-2.508-2.311-6.02-3.419-10.533-3.419H29.523l4.364 6.067h15.8c5.868 0 8.777 2.215 8.777 6.694 0 2.022-.702 3.563-2.107 4.67-1.404 1.108-3.41 1.59-6.069 1.59h-7.272L58.314 62.6h7.724L54.652 46.758a20.733 20.733 0 004.364-1.3z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "rocketfuel-circular_svg__paint0_radial_1683_85794",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(53.661 34.411 -57.959) scale(168.007)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1D0FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088F5"
  })))));
}
export default SvgRocketfuelCircular;